import { useApplicationSettings } from "@/application/providers/application-settings";
import Select, { SelectProps } from "@/shared/form/select";
import { useLocale } from "@/shared/i18n";
import { useRefetchQueriesOnLocalChange } from "@/modules/user-settings/widgets/language-changer/model/use-refetch-queries-on-local-change";

export function LanguageChanger(props: SelectProps) {
  const { locale, setLocale } = useLocale();
  const settings = useApplicationSettings();

  useRefetchQueriesOnLocalChange({ locale });

  return (
    <Select
      value={locale}
      onChange={setLocale}
      options={settings.languages.map((language) => ({
        value: language.toLocaleLowerCase(),
        label: language,
      }))}
      {...props}
    />
  );
}
